// @flow

import React from "react";
import styled from "styled-components";
import Flex from "./flex";

const DialogWrapper = styled.div`
  display: ${({ display }) => (!display ? "none" : "block")};
  position: fixed;
  position: -ms-page;
  top: 60px
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
`;

const DialogBody = styled(Flex)`
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  margin: 0 auto;
  z-index: 1;

  @media(min-width: 992px) {
    max-width: 60%;
  }

  @media(min-width: 1200px) {
    max-width: 60%;
  }
`;

const DialogBlur = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  filter: blur();
  background-image: url(${require("./../../public/assets/images/blur_background.svg")});
`;

class Dialog extends React.Component {
  state = {
    display: false
  };

  render() {
    const { display, onClickOnBlur } = this.props;
    return (
      <DialogWrapper display={display ? display : this.state.display}>
        <DialogBlur onClick={onClickOnBlur ? onClickOnBlur : null} />
        <DialogBody alignItems="flex-start">
          {this.props.children}
        </DialogBody>
      </DialogWrapper>
    );
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/common/dialog.js